// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { DelegatedBatchedMarkersProxy } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/DelegatedBatchedMarkersProxy';
import {
  ERR_CREATE_DELEGATED_BATCHED_MARKERS_PROXY,
  SUC_CREATE_DELEGATED_BATCHED_MARKERS_PROXY,
} from '../../../utils/strings';
import { useCreateSubmission } from '../ledger/useSubmission';

export const useCreateDelegatedBatchedMarkersProxy = () => {
  const { submit } = useCreateSubmission(
    DelegatedBatchedMarkersProxy,
    SUC_CREATE_DELEGATED_BATCHED_MARKERS_PROXY,
    ERR_CREATE_DELEGATED_BATCHED_MARKERS_PROXY,
  );
  return submit;
};
